import { Link } from 'react-router-dom';

const CtaButton = ({extraStyle={}, text, linkTo="/home"}) => {

    return (
        <button>
            <Link to={linkTo} className='text-white bg-pink-500 hover:bg-transparent border-2 border-pink-500 duration-200 px-6 py-1.5 sm:text-lg text-base inline-block' style={extraStyle}>{text}</Link>
        </button>
    )
}

export default CtaButton;